export default "\n<div class=\"container content\">\n\n  <router-outlet></router-outlet>\n\n</div>\n"